module.exports = __webpack_public_path__ + "static/media/CommunityChange.290e5b01.png";